export default [
    {
        trackingLabel: 'twitter',
        name: 'twitter',
        href: 'https://twitter.com/1stdibs',
        icon: 'twitter',
        dataTn: 'social-twitter',
    },
    {
        trackingLabel: 'facebook',
        name: 'facebook',
        href: 'https://www.facebook.com/1stdibs',
        icon: 'facebook',
        dataTn: 'social-facebook',
    },
    {
        trackingLabel: 'pinterest',
        name: 'pinterest',
        href: 'https://www.pinterest.com/1stdibs/',
        icon: 'pinterest',
        dataTn: 'social-pinterest',
    },
    {
        trackingLabel: 'instagram',
        name: 'instagram',
        href: 'https://instagram.com/1stdibs/',
        icon: 'instagram',
        dataTn: 'social-instagram',
    },
];



// WEBPACK FOOTER //
// ./src/components/Footer/messages/socialLinks.js